import { Component, OnInit, Input } from '@angular/core';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';

@Component({
  selector: 'app-error-tooltip',
  templateUrl: './error-tooltip.component.html',
  styleUrls: ['./error-tooltip.component.css']
})
export class ErrorTooltipComponent implements OnInit {

  faExclamationTriangle = faExclamationTriangle;

  @Input()
  error = '';

  constructor() { }

  ngOnInit() {
  }

}
